import { useAuth } from './useAuth';
import { isPlatformAdminEmail } from '@/config/platformAdmins';

/**
 * True quando o usuário logado é super-admin da plataforma (opera o SaaS).
 * Base do acesso ao Laboratório de IA (/admin/ia) e, futuramente, da escrita
 * de configuração global de IA. Camada acima de `isOwner` (que é por clínica).
 */
export function usePlatformAdmin(): boolean {
  const { user, profile } = useAuth();
  return isPlatformAdminEmail(user?.email ?? profile?.email);
}
